import type * as React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from './tooltip';

/**
 * Shows a sender's full name in a tooltip over their name, so two agents who share a first
 * name can be told apart. Renders `children` alone when there is no full name. The name takes
 * keyboard focus so the tooltip opens from Tab as well as hover. `children` must accept a ref.
 */
export function SenderTooltip({ fullName, children }: { fullName?: string | null; children: React.ReactElement }) {
  if (!fullName) return children;
  return (
    <Tooltip>
      <TooltipTrigger asChild tabIndex={0}>
        {children}
      </TooltipTrigger>
      <TooltipContent>{fullName}</TooltipContent>
    </Tooltip>
  );
}
